import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"items":_vm.items,"loading":_vm.loading,"multiple":"","outlined":"","label":_vm.$t('Brand'),"hide-details":"auto","chips":"","deletable-chips":""},model:{value:(_vm.subsetValue),callback:function ($$v) {_vm.subsetValue=$$v},expression:"subsetValue"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }